import { defineComponent as _defineComponent } from 'vue';
import { BPopover } from "bootstrap-vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'ObjectStoreSelectButtonPopover',
    props: {
        target: null,
        title: null
    },
    setup(__props) {
        const boundary = "window"; // don't warp the popover to squeeze it into this modal
        return { __sfc: true, boundary, BPopover };
    }
});
